import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ServiceMethods } from '@feathersjs/feathers';
import { MailList } from 'src/app/models/mail-list';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { parse, ParseResult } from 'papaparse';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { Contact } from 'src/app/models/contact';

@Component({
  selector: 'app-mail-list-details',
  templateUrl: './mail-list-details.component.html',
  styleUrls: ['./mail-list-details.component.scss']
})
export class MailListDetailsComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  id: string;
  mailListService: ServiceMethods<MailList>;
  loading: boolean;
  mailListForm: FormGroup;
  contactList: Contact[];
  contactFields = [
    { key: 'firstName', title: 'MAIL-LIST-DETAILS.FIRSTNAME'},
    { key: 'lastName', title: 'MAIL-LIST-DETAILS.LASTNAME'},
    { key: 'email', title: 'MAIL-LIST-DETAILS.EMAIL'},
    { key: 'company', title: 'MAIL-LIST-DETAILS.COMPANY'},
    { key: 'department', title: 'MAIL-LIST-DETAILS.CLASS'},
    { key: 'mobile', title: 'MAIL-LIST-DETAILS.PHONE'},
  ];
  activeCell: string;
  activeCellControl: FormControl = new FormControl();

  constructor(
    public translate: TranslateService,
    private feathers: VznFeathersService<MailList>,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef
  ) {
    this.translate = translate;
    this.mailListService = this.feathers.service('maillists');
    this.mailListForm = this.formBuilder.group({
      name: ''
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
      this.id = paramMap.get('id');

      if (this.id === 'new') {
        this.loading = false;
      } else {
        const mailList: MailList = new MailList(await this.mailListService.get(this.id));
        this.mailListForm.patchValue(mailList);
        // this.contactList = mailList.contacts;
        this.contactList = mailList.contacts;
        this.loading = false;
      }
    });
  }

  get title() {
    let title: string;
    if (this.id === 'new') {
      title = this.translate.instant('MAIL-LIST-DETAILS.NEW-MAILING-LIST');
    } else {
      title = this.translate.instant('MAIL-LIST-DETAILS.EDIT-MAILING-LIST');
    }

    return title;
  }

  get contactsFormArray() {
    return (this.mailListForm.get('contacts') as FormArray).controls;
  }

  setActiveCell(rowIndex: number, field: string) {
    this.activeCell = `${rowIndex}-${field}`;

    this.activeCellControl.setValue(this.contactList[rowIndex][field]);
  }

  isActive(rowIndex: number, field: string) {
    return `${rowIndex}-${field}` === this.activeCell;
  }

  clearActiveCell(event?: MouseEvent) {
    this.activeCell = '';
    this.cd.markForCheck();

    event?.stopPropagation();
    event?.stopImmediatePropagation();
  }

  saveActiveCell(event?: MouseEvent) {
    event?.stopPropagation();
    event?.stopImmediatePropagation();

    const [rowIndex, field] = this.activeCell.split('-');
    this.contactList[parseInt(rowIndex, 10)][field] = this.activeCellControl.value;

    this.clearActiveCell();
  }


  importContacts(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.fileInput.nativeElement.click();
  }

  onFileSelected() {
    console.log(this.fileInput.nativeElement.files.length);
    if (this.fileInput.nativeElement.files.length > 0) {
      const csvFile: File = this.fileInput.nativeElement.files[0];
      parse(csvFile, {
        header: true,
        complete: (results: ParseResult<any>) => {
          console.log(results);
          this.contactList = results.data;
        }
      })
    }
  }

  async onSubmit() {
    this.loading = true;

    console.log(this.mailListForm.value);
    const mailList = {
      ...this.mailListForm.value,
      contacts: []
    }
    let mailListId = this.id;
    if (this.id === 'new') {
      const mailListResponse: MailList = await this.mailListService.create(mailList) as MailList;
      mailListId = mailListResponse._id;
    } else {
      await this.mailListService.patch(mailListId, mailList);
    }

    const contactsToUpdate = [...this.contactList];
    while (contactsToUpdate.length > 0) {
      const chunk = contactsToUpdate.splice(0, 100);
      await this.mailListService.patch(mailListId, {
        $push: {
          contacts: chunk
        }
      } as any);
    }

    this.router.navigate(['/mail-list-table']);
  }

  delete(event: MouseEvent): void {
    event.preventDefault();
    event.stopImmediatePropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      data: { title: this.translate.instant('MAIL-LIST-DETAILS.ALERT-TITLE'), body: this.translate.instant('MAIL-LIST-DETAILS.ALERT-DESC') }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        await this.mailListService.remove(this.id);
        this.router.navigate(['/mail-list-table']);
      }
    });
  }

}
